import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import './NewDriverMiniForm.scss';

const MOBILE_BREAKPOINT_QUERY = '(max-width: 767px)';

export const useIsMobileViewport = () => {
    const [isMobile, setIsMobile] = React.useState(
        () => typeof window !== 'undefined' && window.matchMedia(MOBILE_BREAKPOINT_QUERY).matches
    );

    React.useEffect(() => {
        const mql = window.matchMedia(MOBILE_BREAKPOINT_QUERY);
        const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, []);

    return isMobile;
};

interface NewDriverMiniFormProps {
    phone: string;
    name: string;
    onPhoneChange: (value: string) => void;
    onNameChange: (value: string) => void;
    onAdd: () => void;
    disabled?: boolean;
    loading?: boolean;
    error?: string | null;
    /** Renderowane między etykietą "Nowy profil kierowcy" a wierszem z polami — np. lista już dodanych profili. */
    children?: React.ReactNode;
}

export const NewDriverMiniForm: React.FC<NewDriverMiniFormProps> = ({
    phone,
    name,
    onPhoneChange,
    onNameChange,
    onAdd,
    disabled = false,
    loading = false,
    error,
    children,
}) => {
    const isMobileViewport = useIsMobileViewport();

    return (
        <div className="new-driver-mini-form">
            <div className="mb-2 font-bold">Nowy profil kierowcy</div>
            {children}
            <div className="new-driver-mini-form__row d-flex align-items-center gap-2">
                <InputText
                    value={phone}
                    onChange={(e) => onPhoneChange(e.target.value)}
                    placeholder="Wprowadź numer"
                    disabled={disabled}
                    className="new-driver-mini-form__field"
                />
                <InputText
                    value={name}
                    onChange={(e) => onNameChange(e.target.value)}
                    placeholder="Wprowadź nazwę"
                    disabled={disabled}
                    className="new-driver-mini-form__field"
                />
                <Button
                    className="p-button-outlined new-driver-mini-form__add-btn"
                    icon={isMobileViewport ? undefined : 'pi pi-plus'}
                    label={isMobileViewport ? 'Dodaj' : undefined}
                    onClick={onAdd}
                    loading={loading}
                    disabled={disabled || !phone.trim() || !name.trim()}
                />
            </div>
            {error && <div className="text-danger small mt-2">{error}</div>}
        </div>
    );
};
